interface Feature {
  icon: string;
  title: string;
  desc: string;
}

const features: Feature[] = [
  {
    icon: 'ri-flashlight-line',
    title: '实时更新 · 快人一步',
    desc: '365天全天候滚动更新，第一时间获取最新吃瓜爆料和黑料曝光。我们的编辑团队实时监控全网动态，确保你不错过任何一个重要内幕。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '多源验证 · 信息靠谱',
    desc: '严格的内容审核机制，每一条爆料均经过多渠道交叉验证。标注信息来源与可信度评级，让吃瓜吃得明明白白，拒绝谣言传播。',
  },
  {
    icon: 'ri-global-line',
    title: '全域覆盖 · 一网打尽',
    desc: '从娱乐圈到网红圈，从社会热点到电竞动态，51吃瓜黑料覆盖所有热门领域。一个平台看遍全网猛料，省去多平台切换的麻烦。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1000px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            为什么选择我们
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            51吃瓜黑料的核心优势
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="flex flex-col items-center text-center p-6 md:p-8 rounded-xl bg-background-50 border border-background-200/70"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 mb-5">
                <i className={`${feature.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading font-bold text-foreground-900 text-base md:text-lg mb-3">
                {feature.title}
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}